module.exports = __webpack_public_path__ + "static/listInsiderInfo_2022-e584004e53471906e1c72ab8efbf816d.pdf";